module.exports = __webpack_public_path__ + "static/media/image (9).3d81b162.jpg";